import { render } from "./CustomsComponent.vue?vue&type=template&id=1d18fd77"
import script from "./CustomsComponent.vue?vue&type=script&lang=js"
export * from "./CustomsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__